/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SupportedLanguages from '../../models/enums/SupportedLanguages';

const initialState = {
  user: null,
  language: SupportedLanguages.DEFAULT,
  municipality: null,
  forms: null,
  municipalities: null,
  reports: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser(state, action: PayloadAction<any>) {
      state.user = action.payload;
    },
    updateLanguage(state, action: PayloadAction<any>) {
      state.language = action.payload;
    },
    updateMunicipality(state, action: PayloadAction<any>) {
      state.municipality = action.payload;
    },
    updateForms(state, action: PayloadAction<any>) {
      state.forms = action.payload;
    },
    updateMunicipalities(state, action: PayloadAction<any>) {
      state.municipalities = action.payload;
    },
    updateReports(state, action: PayloadAction<any>) {
      state.reports = action.payload;
    },
  },
});

export const {
  updateUser,
  updateLanguage,
  updateMunicipality,
  updateForms,
  updateMunicipalities,
  updateReports,
} = userSlice.actions;

export default userSlice;
